/**
 * Auto-generated by yarn cross-type:gen-typescript. Do not edit by hand.
 *
 * @source dashboard/lib/shared/braze/remote_lookup/providers/territory_remote_lookup_provider.rb
 * @owner @Appboy/messaging-experience
 */

import { common } from "../../../../common";

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/territory_remote_lookup_provider.rb) */
export const idTypeSchema = common.objectId;

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/territory_remote_lookup_provider.rb) */
export const idTypeOutputSchema = common.objectId;
